<header class="cw-header">
  <div class="cw-header__bar">
    <div class="cw-header__bar-inner">
      <a class="cw-brand-link" [routerLink]="mode() === 'technician' ? '/siteinductioncompleted' : '/dashboard'" aria-label="City Workbench">
        <img
          class="cw-brand"
          src="/assets/city-onsite-workbench-logo.png"
          alt="City Workbench"
        />
      </a>

      @if (mode() !== 'technician') {
      <nav class="cw-nav" aria-label="Main navigation">
        <button type="button" class="cw-nav__item" [matMenuTriggerFor]="jobsMenu() ?? defaultJobsMenu">
          {{ "workbench_header_jobs" | translate }}
          <svg class="cw-icon-chevron" viewBox="0 0 12 12" aria-hidden="true"><path d="m2 4 4 4 4-4" /></svg>
        </button>
        <button type="button" class="cw-nav__item" [matMenuTriggerFor]="invoicesMenu() ?? defaultInvoicesMenu">
          {{ "workbench_header_invoices" | translate }}
          <svg class="cw-icon-chevron" viewBox="0 0 12 12" aria-hidden="true"><path d="m2 4 4 4 4-4" /></svg>
        </button>
        <span class="cw-nav__item">
          {{ "workbench_header_reference_material" | translate }}
          <svg class="cw-icon-chevron" viewBox="0 0 12 12" aria-hidden="true"><path d="m2 4 4 4 4-4" /></svg>
        </span>
        <span class="cw-nav__item">
          {{ "workbench_header_reports" | translate }}
          <svg class="cw-icon-chevron" viewBox="0 0 12 12" aria-hidden="true"><path d="m2 4 4 4 4-4" /></svg>
        </span>
      </nav>

      <button
        type="button"
        class="cw-header__burger"
        aria-label="Toggle mobile navigation"
        aria-controls="cw-mobile-nav"
        [attr.aria-expanded]="isMobileNavOpen()"
        (click)="toggleMobileNav()"
      >
        <svg viewBox="0 0 24 24"><path d="M4 7h16M4 12h16M4 17h16" /></svg>
      </button>
      }

      <div class="cw-header__right" [class.cw-header__right--technician]="mode() === 'technician'">
        @if (mode() !== 'technician') {
        <label class="cw-search">
          <input class="cw-search__input" type="search" placeholder="Search Jobs" aria-label="Search Jobs" />
          <span class="cw-search__button" aria-hidden="true">
            <svg viewBox="0 0 16 16"><circle cx="7" cy="7" r="4.5" /><path d="m10.5 10.5 3 3" /></svg>
          </span>
        </label>
        }
        <button
          type="button"
          class="cw-resource__toggle"
          [matMenuTriggerFor]="accountMenu"
          #accountMenuTrigger="matMenuTrigger"
          [class.cw-resource__toggle--open]="accountMenuTrigger.menuOpen"
          [attr.title]="selectedCompany()?.name"
        >
          <span class="cw-resource__name">{{ selectedCompany()?.name || ("workbench_header_account" | translate) }}</span>
          <svg class="cw-icon-chevron" viewBox="0 0 12 12" aria-hidden="true"><path d="m2 4 4 4 4-4" /></svg>
        </button>
      </div>
    </div>
  </div>

  @if (mode() !== 'technician') {
  <nav id="cw-mobile-nav" class="cw-mobile-nav" [hidden]="!isMobileNavOpen()" aria-label="Mobile navigation">
    <div class="cw-mobile-nav__inner">
      <button type="button" class="cw-mobile-nav__item" [matMenuTriggerFor]="jobsMenu() ?? defaultJobsMenu">
        {{ "workbench_header_jobs" | translate }}
        <svg class="cw-icon-chevron" viewBox="0 0 12 12" aria-hidden="true"><path d="m2 4 4 4 4-4" /></svg>
      </button>
      <button type="button" class="cw-mobile-nav__item" [matMenuTriggerFor]="invoicesMenu() ?? defaultInvoicesMenu">
        {{ "workbench_header_invoices" | translate }}
        <svg class="cw-icon-chevron" viewBox="0 0 12 12" aria-hidden="true"><path d="m2 4 4 4 4-4" /></svg>
      </button>
      <span class="cw-mobile-nav__item">{{ "workbench_header_reference_material" | translate }}</span>
      <span class="cw-mobile-nav__item">{{ "workbench_header_reports" | translate }}</span>
    </div>
  </nav>
  }
</header>

<mat-menu #defaultJobsMenu="matMenu" class="cw-header-dropdown">
  <a mat-menu-item routerLink="/openjobs">{{ "resource_admin_dashboard_open_jobs" | translate }}</a>
  <button mat-menu-item [disabled]="isRedirectingToWorkbench()" (click)="openWorkbench()">{{ "resource_admin_dashboard_pending_approval_jobs" | translate }}</button>
  <button mat-menu-item [disabled]="isRedirectingToWorkbench()" (click)="openWorkbench()">{{ "resource_admin_dashboard_unallocated_jobs" | translate }}</button>
  <button mat-menu-item [disabled]="isRedirectingToWorkbench()" (click)="openWorkbench()">{{ "resource_admin_dashboard_unallocated_ppm_jobs" | translate }}</button>
</mat-menu>

<mat-menu #accountMenu="matMenu" xPosition="before" class="cw-header-dropdown cw-account-dropdown">
  @if (companyLoadError() || (mode() === 'technician' && resourceCompanyId() && !selectedCompany())) {
    <div class="cw-account-dropdown__message" role="status">{{ "workbench_header_companies_error" | translate }}</div>
  } @else if (visibleCompanies().length) {
    <ul class="cw-account-dropdown__companies" [attr.aria-label]="'workbench_header_companies' | translate">
      @for (company of visibleCompanies(); track company.id) {
        <li class="cw-account-dropdown__company">{{ company.name }}</li>
      }
    </ul>
  }
  <a mat-menu-item routerLink="/userprofile">{{ "workbench_header_manage_profile" | translate }}</a>
  <button mat-menu-item (click)="logout()">{{ "lbl_menu_logout" | translate }}</button>
</mat-menu>

<mat-menu #defaultInvoicesMenu="matMenu" class="cw-header-dropdown">
  <a mat-menu-item routerLink="/jobsawaitinginvoice">{{ "resource_admin_dashboard_jobs_awaiting_invoice" | translate }}</a>
  <a mat-menu-item routerLink="/submittedinvoices">{{ "resource_admin_dashboard_submitted_invoices" | translate }}</a>
</mat-menu>
